var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRefresh03 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M3.515 3.246A5.5 5.5 0 0 1 7 2.006a5 5 0 1 1-5.001 5v-.522h1.042v.522A3.958 3.958 0 1 0 7 3.048a4.46 4.46 0 0 0-2.826 1.005l.034.16-.693-.813z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "square",
  strokeWidth: 0.3,
  d: "M7 2.006a5.5 5.5 0 0 0-3.485 1.24V3.4l.693.814-.034-.161A4.46 4.46 0 0 1 7 3.048a3.958 3.958 0 1 1-3.958 3.958v-.522H2v.522a5 5 0 1 0 5-5Zm0 0v.52"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 1.3,
  d: "m4 1-.5 3.3h3"
})));
export default SvgIconRefresh03;